module.exports = __webpack_public_path__ + "img/d3e403fb-09df-4482-bc42-1f896d529a1b.00b9fe92.png";